import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Loader2, Receipt } from 'lucide-react';
import { useMyRefunds, RefundStatusCard } from '../components/RefundTracker';

export default function MyRefundsPage() {
  const refunds = useMyRefunds();
  return (
    <div className="min-h-screen bg-vault" data-testid="my-refunds-page">
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center gap-3">
          <Link to="/dashboard" data-testid="my-refunds-back-link" className="text-[#A19DB0] hover:text-white transition-colors">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <span className="font-heading text-lg font-bold text-white tracking-tight">My Refunds</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6">
        <p className="text-[#A19DB0] text-sm mb-6">Track every refund from request to your card. Refunds usually land within 5–10 business days.</p>
        {refunds === null ? (
          <Loader2 className="h-8 w-8 animate-spin text-[#9333EA] mx-auto mt-12" data-testid="my-refunds-loading" />
        ) : refunds.length === 0 ? (
          <div className="p-12 text-center bg-[#0A0A0F] rounded-xl border border-white/10" data-testid="my-refunds-empty">
            <Receipt className="h-8 w-8 text-[#9333EA] mx-auto mb-3" />
            <p className="text-white font-semibold">No refunds yet</p>
            <p className="text-[#A19DB0] text-xs mt-1">Any refund you request will show up here.</p>
          </div>
        ) : (
          <div className="space-y-3" data-testid="my-refunds-list">
            {refunds.map((r) => <RefundStatusCard key={r.id} refund={r} showVault />)}
          </div>
        )}
      </main>
    </div>
  );
}
